// eslint-disable-next-line no-unused-vars
var itemsEn = {
    "1": "Master Ball",
    "2": "Ultra Ball",
    "3": "Great Ball",
    "4": "Poké Ball",
    "5": "Safari Ball",
    "6": "Net Ball",
    "7": "Dive Ball",
    "8": "Nest Ball",
    "9": "Repeat Ball",
    "10": "Timer Ball",
    "11": "Luxury Ball",
    "12": "Premier Ball",
    "13": "Dusk Ball",
    "14": "Heal Ball",
    "15": "Quick Ball",
    "16": "Cherish Ball",
    "17": "Potion",
    "18": "Antidote",
    "19": "Burn Heal",
    "20": "Ice Heal",
    "21": "Awakening",
    "22": "Paralyze Heal",
    "23": "Full Restore",
    "24": "Max Potion",
    "25": "Hyper Potion",
    "26": "Super Potion",
    "27": "Full Heal",
    "28": "Revive",
    "29": "Max Revive",
    "30": "Fresh Water",
    "31": "Soda Pop",
    "32": "Lemonade",
    "33": "Moomoo Milk",
    "34": "Energy Powder",
    "35": "Energy Root",
    "36": "Heal Powder",
    "37": "Revival Herb",
    "38": "Ether",
    "39": "Max Ether",
    "40": "Elixir",
    "41": "Max Elixir",
    "42": "Lava Cookie",
    "43": "Berry Juice",
    "44": "Sacred Ash",
    "45": "HP Up",
    "46": "Protein",
    "47": "Iron",
    "48": "Carbos",
    "49": "Calcium",
    "50": "Rare Candy",
    "51": "PP Up",
    "52": "Zinc",
    "53": "PP Max",
    "54": "Old Gateau",
    "55": "Guard Spec.",
    "56": "Dire Hit",
    "57": "X Attack",
    "58": "X Defense",
    "59": "X Speed",
    "60": "X Accuracy",
    "61": "X Sp. Atk",
    "62": "X Sp. Def",
    "63": "Poké Doll",
    "64": "Fluffy Tail",
    "65": "Blue Flute",
    "66": "Yellow Flute",
    "67": "Red Flute",
    "68": "Black Flute",
    "69": "White Flute",
    "70": "Shoal Salt",
    "71": "Shoal Shell",
    "72": "Red Shard",
    "73": "Blue Shard",
    "74": "Yellow Shard",
    "75": "Green Shard",
    "76": "Super Repel",
    "77": "Max Repel",
    "79": "Repel",
    "80": "Sun Stone",
    "81": "Moon Stone",
    "82": "Fire Stone",
    "83": "Thunder Stone",
    "84": "Water Stone",
    "85": "Leaf Stone",
    "86": "Tiny Mushroom",
    "87": "Big Mushroom",
    "88": "Pearl",
    "89": "Big Pearl",
    "90": "Stardust",
    "91": "Star Piece",
    "92": "Nugget",
    "93": "Heart Scale",
    "94": "Honey",
    "95": "Growth Mulch",
    "96": "Damp Mulch",
    "97": "Stable Mulch",
    "98": "Gooey Mulch",
    "99": "Root Fossil",
    "100": "Claw Fossil",
    "101": "Helix Fossil",
    "102": "Dome Fossil",
    "103": "Old Amber",
    "104": "Armor Fossil",
    "105": "Skull Fossil",
    "106": "Rare Bone",
    "107": "Shiny Stone",
    "108": "Dusk Stone",
    "109": "Dawn Stone",
    "110": "Oval Stone",
    "111": "Odd Keystone",
    "112": "Griseous Orb",
    "116": "Douse Drive",
    "117": "Shock Drive",
    "118": "Burn Drive",
    "119": "Chill Drive",
    "120": "???",
    "129": "???",
    "130": "???",
    "131": "???",
    "132": "???",
    "133": "???",
    "134": "Sweet Heart",
    "135": "Adamant Orb",
    "136": "Lustrous Orb",
    "137": "Greet Mail",
    "138": "Favored Mail",
    "139": "RSVP Mail",
    "140": "Thanks Mail",
    "141": "Inquiry Mail",
    "142": "Like Mail",
    "143": "Reply Mail",
    "144": "Bridge Mail S",
    "145": "Bridge Mail D",
    "146": "Bridge Mail T",
    "147": "Bridge Mail V",
    "148": "Bridge Mail M",
    "149": "Cheri Berry",
    "150": "Chesto Berry",
    "151": "Pecha Berry",
    "152": "Rawst Berry",
    "153": "Aspear Berry",
    "154": "Leppa Berry",
    "155": "Oran Berry",
    "156": "Persim Berry",
    "157": "Lum Berry",
    "158": "Sitrus Berry",
    "159": "Figy Berry",
    "160": "Wiki Berry",
    "161": "Mago Berry",
    "162": "Aguav Berry",
    "163": "Iapapa Berry",
    "164": "Razz Berry",
    "165": "Bluk Berry",
    "166": "Nanab Berry",
    "167": "Wepear Berry",
    "168": "Pinap Berry",
    "169": "Pomeg Berry",
    "170": "Kelpsy Berry",
    "171": "Qualot Berry",
    "172": "Hondew Berry",
    "173": "Grepa Berry",
    "174": "Tamato Berry",
    "175": "Cornn Berry",
    "176": "Magost Berry",
    "177": "Rabuta Berry",
    "178": "Nomel Berry",
    "179": "Spelon Berry",
    "180": "Pamtre Berry",
    "181": "Watmel Berry",
    "182": "Durin Berry",
    "183": "Belue Berry",
    "184": "Occa Berry",
    "185": "Passho Berry",
    "186": "Wacan Berry",
    "187": "Rindo Berry",
    "188": "Yache Berry",
    "189": "Chople Berry",
    "190": "Kebia Berry",
    "191": "Shuca Berry",
    "192": "Coba Berry",
    "193": "Payapa Berry",
    "194": "Tanga Berry",
    "195": "Charti Berry",
    "196": "Kasib Berry",
    "197": "Haban Berry",
    "198": "Colbur Berry",
    "199": "Babiri Berry",
    "200": "Chilan Berry",
    "201": "Liechi Berry",
    "202": "Ganlon Berry",
    "203": "Salac Berry",
    "204": "Petaya Berry",
    "205": "Apicot Berry",
    "206": "Lansat Berry",
    "207": "Starf Berry",
    "208": "Enigma Berry",
    "209": "Micle Berry",
    "210": "Custap Berry",
    "211": "Jaboca Berry",
    "212": "Rowap Berry",
    "213": "Bright Powder",
    "214": "White Herb",
    "215": "Macho Brace",
    "217": "Quick Claw",
    "218": "Soothe Bell",
    "219": "Mental Herb",
    "220": "Choice Band",
    "221": "King's Rock",
    "222": "Silver Powder",
    "223": "Amulet Coin",
    "224": "Cleanse Tag",
    "225": "Soul Dew",
    "226": "Deep Sea Tooth",
    "227": "Deep Sea Scale",
    "228": "Smoke Ball",
    "229": "Everstone",
    "230": "Focus Band",
    "231": "Lucky Egg",
    "232": "Scope Lens",
    "233": "Metal Coat",
    "234": "Leftovers",
    "235": "Dragon Scale",
    "236": "Light Ball",
    "237": "Soft Sand",
    "238": "Hard Stone",
    "239": "Miracle Seed",
    "240": "Black Glasses",
    "241": "Black Belt",
    "242": "Magnet",
    "243": "Mystic Water",
    "244": "Sharp Beak",
    "245": "Poison Barb",
    "246": "Never-Melt Ice",
    "247": "Spell Tag",
    "248": "Twisted Spoon",
    "249": "Charcoal",
    "250": "Dragon Fang",
    "251": "Silk Scarf",
    "252": "Upgrade",
    "253": "Shell Bell",
    "254": "Sea Incense",
    "255": "Lax Incense",
    "256": "Lucky Punch",
    "257": "Metal Powder",
    "258": "Thick Club",
    "259": "Leek",
    "260": "Red Scarf",
    "261": "Blue Scarf",
    "262": "Pink Scarf",
    "263": "Green Scarf",
    "264": "Yellow Scarf",
    "265": "Wide Lens",
    "266": "Muscle Band",
    "267": "Wise Glasses",
    "268": "Expert Belt",
    "269": "Light Clay",
    "270": "Life Orb",
    "271": "Power Herb",
    "272": "Toxic Orb",
    "273": "Flame Orb",
    "274": "Quick Powder",
    "275": "Focus Sash",
    "276": "Zoom Lens",
    "277": "Metronome",
    "278": "Iron Ball",
    "279": "Lagging Tail",
    "280": "Destiny Knot",
    "281": "Black Sludge",
    "282": "Icy Rock",
    "283": "Smooth Rock",
    "284": "Heat Rock",
    "285": "Damp Rock",
    "286": "Grip Claw",
    "287": "Choice Scarf",
    "288": "Sticky Barb",
    "289": "Power Bracer",
    "290": "Power Belt",
    "291": "Power Lens",
    "292": "Power Band",
    "293": "Power Anklet",
    "294": "Power Weight",
    "295": "Shed Shell",
    "296": "Big Root",
    "297": "Choice Specs",
    "298": "Flame Plate",
    "299": "Splash Plate",
    "300": "Zap Plate",
    "301": "Meadow Plate",
    "302": "Icicle Plate",
    "303": "Fist Plate",
    "304": "Toxic Plate",
    "305": "Earth Plate",
    "306": "Sky Plate",
    "307": "Mind Plate",
    "308": "Insect Plate",
    "309": "Stone Plate",
    "310": "Spooky Plate",
    "311": "Draco Plate",
    "312": "Dread Plate",
    "313": "Iron Plate",
    "314": "Odd Incense",
    "315": "Rock Incense",
    "316": "Full Incense",
    "317": "Wave Incense",
    "318": "Rose Incense",
    "319": "Luck Incense",
    "320": "Pure Incense",
    "321": "Protector",
    "322": "Electirizer",
    "323": "Magmarizer",
    "324": "Dubious Disc",
    "325": "Reaper Cloth",
    "326": "Razor Claw",
    "327": "Razor Fang",
    "328": "TM001",
    "329": "TM002",
    "330": "TM003",
    "331": "TM004",
    "332": "TM005",
    "333": "TM006",
    "334": "TM007",
    "335": "TM008",
    "336": "TM009",
    "337": "TM010",
    "338": "TM011",
    "339": "TM012",
    "340": "TM013",
    "341": "TM014",
    "342": "TM015",
    "343": "TM016",
    "344": "TM017",
    "345": "TM018",
    "346": "TM019",
    "347": "TM020",
    "348": "TM021",
    "349": "TM022",
    "350": "TM023",
    "351": "TM024",
    "352": "TM025",
    "353": "TM026",
    "354": "TM027",
    "355": "TM028",
    "356": "TM029",
    "357": "TM030",
    "358": "TM031",
    "359": "TM032",
    "360": "TM033",
    "361": "TM034",
    "362": "TM035",
    "363": "TM036",
    "364": "TM037",
    "365": "TM038",
    "366": "TM039",
    "367": "TM040",
    "368": "TM041",
    "369": "TM042",
    "370": "TM043",
    "371": "TM044",
    "372": "TM045",
    "373": "TM046",
    "374": "TM047",
    "375": "TM048",
    "376": "TM049",
    "377": "TM050",
    "378": "TM051",
    "379": "TM052",
    "380": "TM053",
    "381": "TM054",
    "382": "TM055",
    "383": "TM056",
    "384": "TM057",
    "385": "TM058",
    "386": "TM059",
    "387": "TM060",
    "388": "TM061",
    "389": "TM062",
    "390": "TM063",
    "391": "TM064",
    "392": "TM065",
    "393": "TM066",
    "394": "TM067",
    "395": "TM068",
    "396": "TM069",
    "397": "TM070",
    "398": "TM071",
    "399": "TM072",
    "400": "TM073",
    "401": "TM074",
    "402": "TM075",
    "403": "TM076",
    "404": "TM077",
    "405": "TM078",
    "406": "TM079",
    "407": "TM080",
    "408": "TM081",
    "409": "TM082",
    "410": "TM083",
    "411": "TM084",
    "412": "TM085",
    "413": "TM086",
    "414": "TM087",
    "415": "TM088",
    "416": "TM089",
    "417": "TM090",
    "418": "TM091",
    "419": "TM092",
    "426": "TM099",
    "427": "TM100",
    "428": "Explorer Kit",
    "429": "Loot Sack",
    "430": "Rule Book",
    "432": "Point Card",
    "433": "Guidebook",
    "434": "Sticker Case",
    "435": "Fashion Case",
    "436": "Sticker Bag",
    "437": "Pal Pad",
    "438": "Works Key",
    "439": "Old Charm",
    "441": "Red Chain",
    "443": "Vs. Seeker",
    "444": "Coin Case",
    "448": "Sprayduck",
    "449": "Poffin Case",
    "451": "Suite Key",
    "452": "Oak's Letter",
    "453": "Lunar Feather",
    "454": "Member Card",
    "455": "Azure Flute",
    "456": "S.S. Ticket",
    "458": "Magma Stone",
    "459": "Parcel",
    "460": "Coupon 1",
    "461": "Coupon 2",
    "462": "Coupon 3",
    "463": "Storage Key",
    "464": "Secret Medicine",
    "467": "Secret Key",
    "468": "Apricorn Box",
    "469": "Unown Report",
    "470": "Berry Pots",
    "472": "Blue Card",
    "473": "Slowpoke Tail",
    "475": "Card Key",
    "476": "Basement Key",
    "477": "Squirt Bottle",
    "478": "Red Scale",
    "479": "Lost Item",
    "480": "Pass",
    "481": "Machine Part",
    "482": "Silver Feather",
    "483": "Rainbow Feather",
    "484": "Mystery Egg",
    "485": "Red Apricorn",
    "486": "Blue Apricorn",
    "487": "Yellow Apricorn",
    "488": "Green Apricorn",
    "489": "Pink Apricorn",
    "490": "White Apricorn",
    "491": "Black Apricorn",
    "492": "Fast Ball",
    "493": "Level Ball",
    "494": "Lure Ball",
    "495": "Heavy Ball",
    "496": "Love Ball",
    "497": "Friend Ball",
    "498": "Moon Ball",
    "499": "Sport Ball",
    "501": "Photo Album",
    "502": "GB Sounds",
    "504": "Rage Candy Bar",
    "505": "Data Card 01",
    "506": "Data Card 02",
    "507": "Data Card 03",
    "508": "Data Card 04",
    "509": "Data Card 05",
    "510": "Data Card 06",
    "511": "Data Card 07",
    "512": "Data Card 08",
    "513": "Data Card 09",
    "514": "Data Card 10",
    "515": "Data Card 11",
    "516": "Data Card 12",
    "517": "Data Card 13",
    "518": "Data Card 14",
    "519": "Data Card 15",
    "520": "Data Card 16",
    "521": "Data Card 17",
    "522": "Data Card 18",
    "523": "Data Card 19",
    "524": "Data Card 20",
    "525": "Data Card 21",
    "526": "Data Card 22",
    "527": "Data Card 23",
    "528": "Data Card 24",
    "529": "Data Card 25",
    "530": "Data Card 26",
    "531": "Data Card 27",
    "532": "Jade Orb",
    "533": "Lock Capsule",
    "534": "Red Orb",
    "535": "Blue Orb",
    "536": "Enigma Stone",
    "537": "Prism Scale",
    "538": "Eviolite",
    "539": "Float Stone",
    "540": "Rocky Helmet",
    "541": "Air Balloon",
    "542": "Red Card",
    "543": "Ring Target",
    "544": "Binding Band",
    "545": "Absorb Bulb",
    "546": "Cell Battery",
    "547": "Eject Button",
    "548": "Fire Gem",
    "549": "Water Gem",
    "550": "Electric Gem",
    "551": "Grass Gem",
    "552": "Ice Gem",
    "553": "Fighting Gem",
    "554": "Poison Gem",
    "555": "Ground Gem",
    "556": "Flying Gem",
    "557": "Psychic Gem",
    "558": "Bug Gem",
    "559": "Rock Gem",
    "560": "Ghost Gem",
    "561": "Dragon Gem",
    "562": "Dark Gem",
    "563": "Steel Gem",
    "564": "Normal Gem",
    "565": "Health Feather",
    "566": "Muscle Feather",
    "567": "Resist Feather",
    "568": "Genius Feather",
    "569": "Clever Feather",
    "570": "Swift Feather",
    "571": "Pretty Feather",
    "572": "Cover Fossil",
    "573": "Plume Fossil",
    "574": "Liberty Pass",
    "575": "Pass Orb",
    "576": "Dream Ball",
    "577": "Poké Toy",
    "578": "Prop Case",
    "579": "Dragon Skull",
    "580": "Balm Mushroom",
    "581": "Big Nugget",
    "582": "Pearl String",
    "583": "Comet Shard",
    "584": "Relic Copper",
    "585": "Relic Silver",
    "586": "Relic Gold",
    "587": "Relic Vase",
    "588": "Relic Band",
    "589": "Relic Statue",
    "590": "Relic Crown",
    "591": "Casteliacone",
    "592": "Dire Hit 2",
    "593": "X Speed 2",
    "594": "X Sp. Atk 2",
    "595": "X Sp. Def 2",
    "596": "X Defense 2",
    "597": "X Attack 2",
    "598": "X Accuracy 2",
    "599": "X Speed 3",
    "600": "X Sp. Atk 3",
    "601": "X Sp. Def 3",
    "602": "X Defense 3",
    "603": "X Attack 3",
    "604": "X Accuracy 3",
    "605": "X Speed 6",
    "606": "X Sp. Atk 6",
    "607": "X Sp. Def 6",
    "608": "X Defense 6",
    "609": "X Attack 6",
    "610": "X Accuracy 6",
    "611": "Ability Urge",
    "612": "Item Drop",
    "613": "Item Urge",
    "614": "Reset Urge",
    "615": "Dire Hit 3",
    "616": "Light Stone",
    "617": "Dark Stone",
    "618": "TM093",
    "619": "TM094",
    "620": "TM095",
    "621": "Xtransceiver",
    "622": "???",
    "623": "Gram 1",
    "624": "Gram 2",
    "625": "Gram 3",
    "626": "Xtransceiver",
    "627": "Medal Box",
    "630": "Permit",
    "633": "Plasma Card",
    "634": "Grubby Hanky",
    "635": "Colress Machine",
    "636": "Dropped Item",
    "637": "Dropped Item",
    "639": "Weakness Policy",
    "640": "Assault Vest",
    "644": "Pixie Plate",
    "645": "Ability Capsule",
    "646": "Whipped Dream",
    "647": "Sachet",
    "648": "Luminous Moss",
    "649": "Snowball",
    "650": "Safety Goggles",
    "652": "Rich Mulch",
    "653": "Surprise Mulch",
    "654": "Boost Mulch",
    "655": "Amaze Mulch",
    "656": "Gengarite",
    "657": "Gardevoirite",
    "658": "Ampharosite",
    "659": "Venusaurite",
    "660": "Charizardite X",
    "661": "Blastoisinite",
    "662": "Mewtwonite X",
    "663": "Mewtwonite Y",
    "664": "Blazikenite",
    "665": "Medichamite",
    "666": "Houndoominite",
    "667": "Aggronite",
    "668": "Banettite",
    "669": "Tyranitarite",
    "670": "Scizorite",
    "671": "Pinsirite",
    "672": "Aerodactylite",
    "673": "Lucarionite",
    "674": "Abomasite",
    "675": "Kangaskhanite",
    "676": "Gyaradosite",
    "677": "Absolite",
    "678": "Charizardite Y",
    "679": "Alakazite",
    "680": "Heracronite",
    "681": "Mawilite",
    "682": "Manectite",
    "683": "Garchompite",
    "684": "Latiasite",
    "685": "Latiosite",
    "686": "Roseli Berry",
    "687": "Kee Berry",
    "688": "Maranga Berry",
    "690": "TM096",
    "691": "TM097",
    "692": "TM098",
    "693": "TM099",
    "694": "TM100",
    "699": "Discount Coupon",
    "704": "Strange Souvenir",
    "708": "Lumiose Galette",
    "709": "Shalour Sable",
    "710": "Jaw Fossil",
    "711": "Sail Fossil",
    "715": "Fairy Gem",
    "752": "Swampertite",
    "753": "Sceptilite",
    "754": "Sablenite",
    "755": "Altarianite",
    "756": "Galladite",
    "757": "Audinite",
    "758": "Metagrossite",
    "759": "Sharpedonite",
    "760": "Slowbronite",
    "761": "Steelixite",
    "762": "Pidgeotite",
    "763": "Glalitite",
    "764": "Diancite",
    "767": "Cameruptite",
    "768": "Lopunnite",
    "769": "Salamencite",
    "770": "Beedrillite",
    "776": "Normalium Z",
    "777": "Firium Z",
    "778": "Waterium Z",
    "779": "Electrium Z",
    "780": "Grassium Z",
    "781": "Icium Z",
    "782": "Fightinium Z",
    "783": "Poisonium Z",
    "784": "Groundium Z",
    "785": "Flyinium Z",
    "786": "Psychium Z",
    "787": "Buginium Z",
    "788": "Rockium Z",
    "789": "Ghostium Z",
    "790": "Dragonium Z",
    "791": "Darkinium Z",
    "792": "Steelium Z",
    "793": "Fairium Z",
    "794": "Pikanium Z",
    "795": "Bottle Cap",
    "796": "Gold Bottle Cap",
    "798": "Decidium Z",
    "799": "Incinium Z",
    "800": "Primarium Z",
    "801": "Tapunium Z",
    "802": "Marshadium Z",
    "803": "Aloraichium Z",
    "804": "Snorlium Z",
    "805": "Eevium Z",
    "806": "Mewnium Z",
    "807": "Normalium Z",
    "808": "Firium Z",
    "809": "Waterium Z",
    "810": "Electrium Z",
    "811": "Grassium Z",
    "812": "Icium Z",
    "813": "Fightinium Z",
    "814": "Poisonium Z",
    "815": "Groundium Z",
    "816": "Flyinium Z",
    "817": "Psychium Z",
    "818": "Buginium Z",
    "819": "Rockium Z",
    "820": "Ghostium Z",
    "821": "Dragonium Z",
    "822": "Darkinium Z",
    "823": "Steelium Z",
    "824": "Fairium Z",
    "825": "Pikanium Z",
    "826": "Decidium Z",
    "827": "Incinium Z",
    "828": "Primarium Z",
    "829": "Tapunium Z",
    "830": "Marshadium Z",
    "831": "Aloraichium Z",
    "832": "Snorlium Z",
    "833": "Eevium Z",
    "834": "Mewnium Z",
    "835": "Pikashunium Z",
    "836": "Pikashunium Z",
    "844": "Festival Ticket",
    "846": "Adrenaline Orb",
    "849": "Ice Stone",
    "851": "Beast Ball",
    "852": "Big Malasada",
    "853": "Red Nectar",
    "854": "Yellow Nectar",
    "855": "Pink Nectar",
    "856": "Purple Nectar",
    "861": "Silver Razz Berry",
    "862": "Golden Razz Berry",
    "863": "Silver Nanab Berry",
    "864": "Golden Nanab Berry",
    "865": "Silver Pinap Berry",
    "866": "Golden Pinap Berry",
    "867": "???",
    "868": "???",
    "869": "???",
    "870": "???",
    "871": "???",
    "879": "Terrain Extender",
    "880": "Protective Pads",
    "881": "Electric Seed",
    "882": "Psychic Seed",
    "883": "Misty Seed",
    "884": "Grassy Seed",
    "885": "Stretchy Spring",
    "886": "Chalky Stone",
    "887": "Marble",
    "888": "Lone Earring",
    "889": "Beach Glass",
    "890": "Gold Leaf",
    "891": "Silver Leaf",
    "892": "Polished Mud Ball",
    "893": "Tropical Shell",
    "894": "Leaf Letter",
    "895": "Leaf Letter",
    "896": "Small Bouquet",
    "897": "???",
    "898": "???",
    "899": "???",
    "900": "Lure",
    "901": "Super Lure",
    "902": "Max Lure",
    "903": "Pewter Crunchies",
    "904": "Fighting Memory",
    "905": "Flying Memory",
    "906": "Poison Memory",
    "907": "Ground Memory",
    "908": "Rock Memory",
    "909": "Bug Memory",
    "910": "Ghost Memory",
    "911": "Steel Memory",
    "912": "Fire Memory",
    "913": "Water Memory",
    "914": "Grass Memory",
    "915": "Electric Memory",
    "916": "Psychic Memory",
    "917": "Ice Memory",
    "918": "Dragon Memory",
    "919": "Dark Memory",
    "920": "Fairy Memory",
    "921": "Solganium Z",
    "922": "Lunalium Z",
    "923": "Ultranecrozium Z",
    "924": "Mimikium Z",
    "925": "Lycanium Z",
    "926": "Kommonium Z",
    "927": "Solganium Z",
    "928": "Lunalium Z",
    "929": "Ultranecrozium Z",
    "930": "Mimikium Z",
    "931": "Lycanium Z",
    "932": "Kommonium Z",
    "949": "Roto Hatch",
    "950": "Roto Bargain",
    "951": "Roto Prize Money",
    "952": "Roto Exp. Points",
    "953": "Roto Friendship",
    "954": "Roto Encounter",
    "955": "Roto Stealth",
    "956": "Roto HP Restore",
    "957": "Roto PP Restore",
    "958": "Roto Boost",
    "959": "Roto Catch",
    "960": "Health Candy",
    "961": "Mighty Candy",
    "962": "Tough Candy",
    "963": "Smart Candy",
    "964": "Courage Candy",
    "965": "Quick Candy",
    "966": "Health Candy L",
    "967": "Mighty Candy L",
    "968": "Tough Candy L",
    "969": "Smart Candy L",
    "970": "Courage Candy L",
    "971": "Quick Candy L",
    "972": "Health Candy XL",
    "973": "Mighty Candy XL",
    "974": "Tough Candy XL",
    "975": "Smart Candy XL",
    "976": "Courage Candy XL",
    "977": "Quick Candy XL",
    "978": "{Bulbasaur} Candy",
    "979": "{Charmander} Candy",
    "980": "{Squirtle} Candy",
    "981": "{Caterpie} Candy",
    "982": "{Weedle} Candy",
    "983": "{Pidgey} Candy",
    "984": "{Rattata} Candy",
    "985": "{Spearow} Candy",
    "986": "{Ekans} Candy",
    "987": "{Pikachu} Candy",
    "988": "{Sandshrew} Candy",
    "989": "{Nidoran[Character1:female ]} Candy",
    "990": "{Nidoran[Character1:male ]} Candy",
    "991": "{Clefairy} Candy",
    "992": "{Vulpix} Candy",
    "993": "{Jigglypuff} Candy",
    "994": "{Zubat} Candy",
    "995": "{Oddish} Candy",
    "996": "{Paras} Candy",
    "997": "{Venonat} Candy",
    "998": "{Diglett} Candy",
    "999": "{Meowth} Candy",
    "1000": "{Psyduck} Candy",
    "1001": "{Mankey} Candy",
    "1002": "{Growlithe} Candy",
    "1003": "{Poliwag} Candy",
    "1004": "{Abra} Candy",
    "1005": "{Machop} Candy",
    "1006": "{Bellsprout} Candy",
    "1007": "{Tentacool} Candy",
    "1008": "{Geodude} Candy",
    "1009": "{Ponyta} Candy",
    "1010": "{Slowpoke} Candy",
    "1011": "{Magnemite} Candy",
    "1012": "{Farfetch'd} Candy",
    "1013": "{Doduo} Candy",
    "1014": "{Seel} Candy",
    "1015": "{Grimer} Candy",
    "1016": "{Shellder} Candy",
    "1017": "{Gastly} Candy",
    "1018": "{Onix} Candy",
    "1019": "{Drowzee} Candy",
    "1020": "{Krabby} Candy",
    "1021": "{Voltorb} Candy",
    "1022": "{Exeggcute} Candy",
    "1023": "{Cubone} Candy",
    "1024": "{Hitmonlee} Candy",
    "1025": "{Hitmonchan} Candy",
    "1026": "{Lickitung} Candy",
    "1027": "{Koffing} Candy",
    "1028": "{Rhyhorn} Candy",
    "1029": "{Chansey} Candy",
    "1030": "{Tangela} Candy",
    "1031": "{Kangaskhan} Candy",
    "1032": "{Horsea} Candy",
    "1033": "{Goldeen} Candy",
    "1034": "{Staryu} Candy",
    "1035": "{Mr. Mime} Candy",
    "1036": "{Scyther} Candy",
    "1037": "{Jynx} Candy",
    "1038": "{Electabuzz} Candy",
    "1039": "{Pinsir} Candy",
    "1040": "{Tauros} Candy",
    "1041": "{Magikarp} Candy",
    "1042": "{Lapras} Candy",
    "1043": "{Ditto} Candy",
    "1044": "{Eevee} Candy",
    "1045": "{Porygon} Candy",
    "1046": "{Omanyte} Candy",
    "1047": "{Kabuto} Candy",
    "1048": "{Aerodactyl} Candy",
    "1049": "{Snorlax} Candy",
    "1050": "{Articuno} Candy",
    "1051": "{Zapdos} Candy",
    "1052": "{Moltres} Candy",
    "1053": "{Dratini} Candy",
    "1054": "{Mewtwo} Candy",
    "1055": "{Mew} Candy",
    "1056": "Meltan Candy",
    "1057": "Magmar Candy",
    "1058": "???",
    "1059": "???",
    "1060": "???",
    "1061": "???",
    "1062": "???",
    "1063": "???",
    "1064": "???",
    "1065": "???",
    "1066": "???",
    "1067": "???",
    "1068": "???",
    "1069": "???",
    "1070": "???",
    "1071": "???",
    "1072": "???",
    "1073": "???",
    "1084": "Sausages",
    "1085": "Bob's Food Tin",
    "1086": "Bach's Food Tin",
    "1087": "Tin of Beans",
    "1088": "Bread",
    "1089": "Pasta",
    "1090": "Mixed Mushrooms",
    "1091": "Smoke-Poke Tail",
    "1092": "Large Leek",
    "1093": "Fancy Apple",
    "1094": "Brittle Bones",
    "1095": "Pack of Potatoes",
    "1096": "Pungent Root",
    "1097": "Salad Mix",
    "1098": "Fried Food",
    "1099": "Boiled Egg",
    "1103": "Rusted Sword",
    "1104": "Rusted Shield",
    "1105": "Fossilized Bird",
    "1106": "Fossilized Fish",
    "1107": "Fossilized Drake",
    "1108": "Fossilized Dino",
    "1109": "Strawberry Sweet",
    "1110": "Love Sweet",
    "1111": "Berry Sweet",
    "1112": "Clover Sweet",
    "1113": "Flower Sweet",
    "1114": "Star Sweet",
    "1115": "Ribbon Sweet",
    "1116": "Sweet Apple",
    "1117": "Tart Apple",
    "1118": "Throat Spray",
    "1119": "Eject Pack",
    "1120": "Heavy-Duty Boots",
    "1121": "Blunder Policy",
    "1122": "Room Service",
    "1123": "Utility Umbrella",
    "1124": "Exp. Candy XS",
    "1125": "Exp. Candy S",
    "1126": "Exp. Candy M",
    "1127": "Exp. Candy L",
    "1128": "Exp. Candy XL",
    "1129": "Dynamax Candy",
    "1130": "TR00",
    "1131": "TR01",
    "1132": "TR02",
    "1133": "TR03",
    "1134": "TR04",
    "1135": "TR05",
    "1136": "TR06",
    "1137": "TR07",
    "1138": "TR08",
    "1139": "TR09",
    "1140": "TR10",
    "1141": "TR11",
    "1142": "TR12",
    "1143": "TR13",
    "1144": "TR14",
    "1145": "TR15",
    "1146": "TR16",
    "1147": "TR17",
    "1148": "TR18",
    "1149": "TR19",
    "1150": "TR20",
    "1151": "TR21",
    "1152": "TR22",
    "1153": "TR23",
    "1154": "TR24",
    "1155": "TR25",
    "1156": "TR26",
    "1157": "TR27",
    "1158": "TR28",
    "1159": "TR29",
    "1160": "TR30",
    "1161": "TR31",
    "1162": "TR32",
    "1163": "TR33",
    "1164": "TR34",
    "1165": "TR35",
    "1166": "TR36",
    "1167": "TR37",
    "1168": "TR38",
    "1169": "TR39",
    "1170": "TR40",
    "1171": "TR41",
    "1172": "TR42",
    "1173": "TR43",
    "1174": "TR44",
    "1175": "TR45",
    "1176": "TR46",
    "1177": "TR47",
    "1178": "TR48",
    "1179": "TR49",
    "1180": "TR50",
    "1181": "TR51",
    "1182": "TR52",
    "1183": "TR53",
    "1184": "TR54",
    "1185": "TR55",
    "1186": "TR56",
    "1187": "TR57",
    "1188": "TR58",
    "1189": "TR59",
    "1190": "TR60",
    "1191": "TR61",
    "1192": "TR62",
    "1193": "TR63",
    "1194": "TR64",
    "1195": "TR65",
    "1196": "TR66",
    "1197": "TR67",
    "1198": "TR68",
    "1199": "TR69",
    "1200": "TR70",
    "1201": "TR71",
    "1202": "TR72",
    "1203": "TR73",
    "1204": "TR74",
    "1205": "TR75",
    "1206": "TR76",
    "1207": "TR77",
    "1208": "TR78",
    "1209": "TR79",
    "1210": "TR80",
    "1211": "TR81",
    "1212": "TR82",
    "1213": "TR83",
    "1214": "TR84",
    "1215": "TR85",
    "1216": "TR86",
    "1217": "TR87",
    "1218": "TR88",
    "1219": "TR89",
    "1220": "TR90",
    "1221": "TR91",
    "1222": "TR92",
    "1223": "TR93",
    "1224": "TR94",
    "1225": "TR95",
    "1226": "TR96",
    "1227": "TR97",
    "1228": "TR98",
    "1229": "TR99",
    "1230": "TM00",
    "1231": "Lonely Mint",
    "1232": "Adamant Mint",
    "1233": "Naughty Mint",
    "1234": "Brave Mint",
    "1235": "Bold Mint",
    "1236": "Impish Mint",
    "1237": "Lax Mint",
    "1238": "Relaxed Mint",
    "1239": "Modest Mint",
    "1240": "Mild Mint",
    "1241": "Rash Mint",
    "1242": "Quiet Mint",
    "1243": "Calm Mint",
    "1244": "Gentle Mint",
    "1245": "Careful Mint",
    "1246": "Sassy Mint",
    "1247": "Timid Mint",
    "1248": "Hasty Mint",
    "1249": "Jolly Mint",
    "1250": "Naive Mint",
    "1251": "Serious Mint",
    "1252": "Wishing Piece",
    "1253": "Cracked Pot",
    "1254": "Chipped Pot",
    "1256": "Fruit Bunch",
    "1257": "Moomoo Cheese",
    "1258": "Spice Mix",
    "1259": "Fresh Cream",
    "1260": "Packaged Curry",
    "1261": "Coconut Milk",
    "1262": "Instant Noodles",
    "1263": "Precooked Burger",
    "1264": "Gigantamix",
    "1265": "Wishing Chip",
    "1268": "???",
    "1579": "Max Honey",
    "1580": "Max Mushrooms",
    "1581": "Galarica Twig",
    "1582": "Galarica Cuff",
    "1588": "Armorite Ore",
    "1592": "Galarica Wreath",
    "1604": "Dynite Ore",
    "1606": "Ability Patch",
    "1608": "Time Balm",
    "1609": "Space Balm",
    "1610": "Mysterious Balm",
    "1611": "Linking Cord",
    "1612": "Hometown Muffin",
    "1613": "Apricorn",
    "1614": "Jubilife Muffin",
    "1615": "Aux Powerguard",
    "1616": "Dire Hit",
    "1617": "Choice Dumpling",
    "1618": "Twice-Spiced Radish",
    "1619": "Swap Snack",
    "1620": "Caster Fern",
    "1621": "Seed of Mastery",
    "1622": "Poké Ball",
    "1623": "???",
    "1624": "Eternal Ice",
    "1625": "Uxie's Claw",
    "1626": "Azelf's Fang",
    "1627": "Mesprit's Plume",
    "1628": "Tumblestone",
    "1629": "Celestica Flute",
    "1630": "Remedy",
    "1631": "Fine Remedy",
    "1632": "Dazzling Honey",
    "1633": "Hearty Grains",
    "1634": "Plump Beans",
    "1635": "Springy Mushroom",
    "1636": "Crunchy Salt",
    "1637": "Wood",
    "1638": "King's Leaf",
    "1639": "Marsh Balm",
    "1640": "Poké Ball",
    "1641": "Great Ball",
    "1642": "Ultra Ball",
    "1643": "Feather Ball",
    "1644": "Pokéshi Doll",
    "1645": "???",
    "1646": "Smoke Bomb",
    "1647": "Scatter Bang",
    "1648": "Sticky Glob",
    "1649": "Star Piece",
    "1650": "Mushroom Cake",
    "1651": "Bugwort",
    "1652": "Honey Cake",
    "1653": "Grain Cake",
    "1654": "Bean Cake",
    "1655": "Salt Cake",
    "1656": "Potion",
    "1657": "Super Potion",
    "1658": "Hyper Potion",
    "1659": "Max Potion",
    "1660": "Full Restore",
    "1661": "Remedy",
    "1662": "Fine Remedy",
    "1663": "Superb Remedy",
    "1664": "Old Gateau",
    "1665": "Jubilife Muffin",
    "1666": "Full Heal",
    "1667": "Revive",
    "1668": "Max Revive",
    "1669": "Max Ether",
    "1670": "Max Elixir",
    "1671": "Stealth Spray",
    "1672": "???",
    "1673": "Aux Power",
    "1674": "Aux Guard",
    "1675": "Dire Hit",
    "1676": "Aux Evasion",
    "1677": "Aux Powerguard",
    "1678": "Forest Balm",
    "1679": "Iron Chunk",
    "1680": "???",
    "1681": "Black Tumblestone",
    "1682": "Sky Tumblestone",
    "1683": "???",
    "1684": "Ball of Mud",
    "1685": "???",
    "1686": "Pop Pod",
    "1687": "Sootfoot Root",
    "1688": "Spoiled Apricorn",
    "1689": "Snowball",
    "1690": "Sticky Glob",
    "1691": "Black Augurite",
    "1692": "Peat Block",
    "1693": "Stealth Spray",
    "1694": "Medicinal Leek",
    "1695": "Vivichoke",
    "1696": "Pep-Up Plant",
    "1697": "???",
    "1698": "???",
    "1699": "Tempting Charm B",
    "1700": "Tempting Charm P",
    "1701": "Swordcap",
    "1702": "Iron Barktongue",
    "1703": "Doppel Bonnets",
    "1704": "Direshroom",
    "1705": "Sand Radish",
    "1706": "Tempting Charm T",
    "1707": "Tempting Charm Y",
    "1708": "Candy Truffle",
    "1709": "Cake-Lure Base",
    "1710": "Poké Ball",
    "1711": "Great Ball",
    "1712": "Ultra Ball",
    "1713": "Feather Ball",
    "1714": "???",
    "1715": "???",
    "1716": "Scatter Bang",
    "1717": "Smoke Bomb",
    "1718": "???",
    "1719": "???",
    "1720": "Pokéshi Doll",
    "1721": "Volcano Balm",
    "1722": "Mountain Balm",
    "1723": "Snow Balm",
    "1724": "Honey Cake",
    "1725": "Grain Cake",
    "1726": "Bean Cake",
    "1727": "Mushroom Cake",
    "1728": "Salt Cake",
    "1729": "Swap Snack",
    "1730": "Choice Dumpling",
    "1731": "Twice-Spiced Radish",
    "1732": "Survival Charm R",
    "1733": "Survival Charm B",
    "1734": "Survival Charm P",
    "1735": "Survival Charm T",
    "1736": "Survival Charm Y",
    "1737": "Torn Journal",
    "1738": "Warding Charm R",
    "1739": "Warding Charm B",
    "1740": "Warding Charm P",
    "1741": "Warding Charm T",
    "1742": "Warding Charm Y",
    "1743": "Wall Fragment",
    "1744": "Basculegion Food",
    "1745": "Old Journal",
    "1746": "Wing Ball",
    "1747": "Jet Ball",
    "1748": "Heavy Ball",
    "1749": "Leaden Ball",
    "1750": "Gigaton Ball",
    "1751": "Wing Ball",
    "1752": "Jet Ball",
    "1753": "Heavy Ball",
    "1754": "Hopo Berry",
    "1755": "Superb Remedy",
    "1756": "Aux Power",
    "1757": "Aux Guard",
    "1758": "Aux Evasion",
    "1759": "Grit Dust",
    "1760": "Grit Gravel",
    "1761": "Grit Pebble",
    "1762": "Grit Rock",
    "1763": "Secret Medicine",
    "1764": "Tempting Charm R",
    "1765": "Lost Satchel",
    "1766": "Lost Satchel",
    "1767": "Lost Satchel",
    "1768": "Lost Satchel",
    "1769": "Lost Satchel",
    "1770": "???",
    "1771": "Origin Ball",
    "1772": "???",
    "1773": "???",
    "1774": "???",
    "1775": "???",
    "1776": "Origin Ore",
    "1777": "Adamant Crystal",
    "1778": "Lustrous Globe",
    "1779": "Griseous Core",
    "1780": "Blank Plate",
    "1781": "???",
    "1782": "Crafting Kit",
    "1783": "Leaden Ball",
    "1784": "Gigaton Ball",
    "1785": "Strange Ball",
    "1786": "Pokédex",
    "1787": "Old Verse 1",
    "1788": "Old Verse 2",
    "1789": "Old Verse 3",
    "1790": "Old Verse 4",
    "1791": "???",
    "1792": "Old Verse 5",
    "1793": "Old Verse 6",
    "1794": "Old Verse 7",
    "1795": "Old Verse 8",
    "1796": "Old Verse 9",
    "1797": "Old Verse 10",
    "1798": "Old Verse 11",
    "1799": "Old Verse 12",
    "1800": "Old Verse 13",
    "1801": "Old Verse 14",
    "1802": "Old Verse 15",
    "1803": "Old Verse 16",
    "1804": "Old Verse 17",
    "1805": "Old Verse 18",
    "1806": "Old Verse 19",
    "1807": "Old Verse 20",
    "1808": "Mysterious Shard S",
    "1809": "Mysterious Shard L",
    "1810": "Digger Drill",
    "1811": "Kanto Slate",
    "1812": "Johto Slate",
    "1813": "Soul Slate",
    "1814": "Rainbow Slate",
    "1815": "Squall Slate",
    "1816": "Oceanic Slate",
    "1817": "Tectonic Slate",
    "1818": "Stratospheric Slate",
    "1819": "Genome Slate",
    "1820": "Discovery Slate",
    "1821": "Distortion Slate",
    "1822": "DS Sounds",
    "1828": "Legend Plate",
    "1842": "Tiny Bamboo Shoot",
    "1843": "Big Bamboo Shoot",
    "1861": "Malicious Armor",
    "1862": "Normal Tera Shard",
    "1863": "Fire Tera Shard",
    "1864": "Water Tera Shard",
    "1865": "Electric Tera Shard",
    "1866": "Grass Tera Shard",
    "1867": "Ice Tera Shard",
    "1868": "Fighting Tera Shard",
    "1869": "Poison Tera Shard",
    "1870": "Ground Tera Shard",
    "1871": "Flying Tera Shard",
    "1872": "Psychic Tera Shard",
    "1873": "Bug Tera Shard",
    "1874": "Rock Tera Shard",
    "1875": "Ghost Tera Shard",
    "1876": "Dragon Tera Shard",
    "1877": "Dark Tera Shard",
    "1878": "Steel Tera Shard",
    "1879": "Fairy Tera Shard",
    "1880": "Booster Energy",
    "1881": "Ability Shield",
    "1882": "Clear Amulet",
    "1883": "Mirror Herb",
    "1884": "Punching Glove",
    "1885": "Covert Cloak",
    "1886": "Loaded Dice",
    "2160": "TM100",
    "2161": "TM101",
    "2162": "TM102",
    "2163": "TM103",
    "2164": "TM104",
    "2165": "TM105",
    "2166": "TM106",
    "2167": "TM107",
    "2168": "TM108",
    "2169": "TM109",
    "2170": "TM110",
    "2171": "TM111",
    "2172": "TM112",
    "2173": "TM113",
    "2174": "TM114",
    "2175": "TM115",
    "2176": "TM116",
    "2177": "TM117",
    "2178": "TM118",
    "2179": "TM119",
    "2180": "TM120",
    "2181": "TM121",
    "2182": "TM122",
    "2183": "TM123",
    "2184": "TM124",
    "2185": "TM125",
    "2186": "TM126",
    "2187": "TM127",
    "2188": "TM128",
    "2189": "TM129",
    "2190": "TM130",
    "2191": "TM131",
    "2192": "TM132",
    "2193": "TM133",
    "2194": "TM134",
    "2195": "TM135",
    "2196": "TM136",
    "2197": "TM137",
    "2198": "TM138",
    "2199": "TM139",
    "2200": "TM140",
    "2201": "TM141",
    "2202": "TM142",
    "2203": "TM143",
    "2204": "TM144",
    "2205": "TM145",
    "2206": "TM146",
    "2207": "TM147",
    "2208": "TM148",
    "2209": "TM149",
    "2210": "TM150",
    "2211": "TM151",
    "2212": "TM152",
    "2213": "TM153",
    "2214": "TM154",
    "2215": "TM155",
    "2216": "TM156",
    "2217": "TM157",
    "2218": "TM158",
    "2219": "TM159",
    "2220": "TM160",
    "2221": "TM161",
    "2222": "TM162",
    "2223": "TM163",
    "2224": "TM164",
    "2225": "TM165",
    "2226": "TM166",
    "2227": "TM167",
    "2228": "TM168",
    "2229": "TM169",
    "2230": "TM170",
    "2231": "TM171",
    "2232": "TM172",
    "2233": "TM173",
    "2234": "TM174",
    "2235": "TM175",
    "2236": "TM176",
    "2237": "TM177",
    "2238": "TM178",
    "2239": "TM179",
    "2240": "TM180",
    "2241": "TM181",
    "2242": "TM182",
    "2243": "TM183",
    "2244": "TM184",
    "2245": "TM185",
    "2246": "TM186",
    "2247": "TM187",
    "2248": "TM188",
    "2249": "TM189",
    "2250": "TM190",
    "2251": "TM191",
    "2252": "TM192",
    "2253": "TM193",
    "2254": "TM194",
    "2255": "TM195",
    "2256": "TM196",
    "2257": "TM197",
    "2258": "TM198",
    "2259": "TM199",
    "2260": "TM200",
    "2261": "TM201",
    "2262": "TM202",
    "2263": "TM203",
    "2264": "TM204",
    "2265": "TM205",
    "2266": "TM206",
    "2267": "TM207",
    "2268": "TM208",
    "2269": "TM209",
    "2270": "TM210",
    "2271": "TM211",
    "2272": "TM212",
    "2273": "TM213",
    "2274": "TM214",
    "2275": "TM215",
    "2276": "TM216",
    "2277": "TM217",
    "2278": "TM218",
    "2279": "TM219",
    "2280": "TM220",
    "2281": "TM221",
    "2282": "TM222",
    "2283": "TM223",
    "2284": "TM224",
    "2285": "TM225",
    "2286": "TM226",
    "2287": "TM227",
    "2288": "TM228",
    "2289": "TM229",
    "2344": "Auspicious Armor",
    "2345": "Leader's Crest",
    "2401": "Fairy Feather",
    "2402": "Syrupy Apple",
    "2403": "Unremarkable Teacup",
    "2404": "Masterpiece Teacup",
    "2405": "Teal Mask",
    "2406": "Cornerstone Mask",
    "2407": "Wellspring Mask",
    "2408": "Hearthflame Mask",
    "2409": "Teal Style Card",
    "2410": "Crystal Cluster",
    "2411": "Health Mochi",
    "2412": "Muscle Mochi",
    "2413": "Resist Mochi",
    "2414": "Genius Mochi",
    "2415": "Clever Mochi",
    "2416": "Swift Mochi",
    "2417": "Simple Chairs",
    "2418": "Academy Chairs",
    "2419": "Academy Chairs",
    "2420": "Whimsical Chairs",
    "2421": "Leafy Chairs",
    "2422": "Spooky Chairs",
    "2423": "Plaid Chairs (Y)",
    "2424": "Plaid Chairs (B)",
    "2425": "Plaid Chairs (R)",
    "2426": "B&W Grass Chairs",
    "2427": "Battle Chairs",
    "2428": "Monstrous Chairs",
    "2429": "Striped Chairs",
    "2430": "Diamond Chairs",
    "2431": "Polka-Dot Chairs",
    "2432": "Lilac Chairs",
    "2433": "Mint Chairs",
    "2434": "Peach Chairs",
    "2435": "Yellow Chairs",
    "2436": "Blue Chairs",
    "2437": "Pink Chairs",
    "2438": "Ekans Fang",
    "2439": "Sandshrew Claw",
    "2440": "Cleffa Fur",
    "2441": "Vulpix Fur",
    "2442": "Poliwag Slime",
    "2443": "Bellsprout Vine",
    "2444": "Geodude Fragment",
    "2445": "Koffing Gas",
    "2446": "Munchlax Fang",
    "2447": "Sentret Fur",
    "2448": "Hoothoot Feather",
    "2449": "Spinarak Thread",
    "2450": "Aipom Hair",
    "2451": "Yanma Spike",
    "2452": "Gligar Fang",
    "2453": "Slugma Lava",
    "2454": "Swinub Hair",
    "2455": "Poochyena Fang",
    "2456": "Lotad Leaf",
    "2457": "Seedot Stem",
    "2458": "Nosepass Fragment",
    "2459": "Volbeat Fluid",
    "2460": "Illumise Fluid",
    "2461": "Corphish Shell",
    "2462": "Feebas Scales",
    "2463": "Duskull Fragment",
    "2464": "Chingling Fragment",
    "2465": "Timburr Sweat",
    "2466": "Sewaddle Leaf",
    "2467": "Ducklett Feather",
    "2468": "Litwick Soot",
    "2469": "Mienfoo Claw",
    "2470": "Vullaby Feather",
    "2471": "Carbink Jewel",
    "2472": "Phantump Twig",
    "2473": "Grubbin Thread",
    "2474": "Cutiefly Powder",
    "2475": "Jangmo-o Scales",
    "2476": "Cramorant Down",
    "2477": "Morpeko Snack",
    "2478": "Poltchageist Powder",
    "2479": "Fresh-Start Mochi",
    "2480": "Roto-Stick",
    "2481": "Glimmering Charm",
    "2482": "Metal Alloy",
    "2483": "Indigo Style Card",
    "2484": "Oddish Leaf",
    "2485": "Tentacool Stinger",
    "2486": "Doduo Down",
    "2487": "Seel Fur",
    "2488": "Exeggcute Shell",
    "2489": "Tyrogue Sweat",
    "2490": "Rhyhorn Fang",
    "2491": "Horsea Ink",
    "2492": "Elekid Fur",
    "2493": "Magby Hair",
    "2494": "Lapras Teardrop",
    "2495": "Porygon Fragment",
    "2496": "Chinchou Sparks",
    "2497": "Snubbull Hair",
    "2498": "Skarmory Feather",
    "2499": "Smeargle Paint",
    "2500": "Plusle Fur",
    "2501": "Minun Fur",
    "2502": "Trapinch Shell",
    "2503": "Beldum Claw",
    "2504": "Cranidos Spike",
    "2505": "Shieldon Claw",
    "2506": "Blitzle Mane Hair",
    "2507": "Drilbur Claw",
    "2508": "Cottonee Fluff",
    "2509": "Scraggy Sweat",
    "2510": "Minccino Fur",
    "2511": "Solosis Gel",
    "2512": "Joltik Thread",
    "2513": "Golett Shard",
    "2514": "Espurr Fur",
    "2515": "Inkay Ink",
    "2516": "Pikipek Feather",
    "2517": "Dewpider Thread",
    "2518": "Comfey Flower",
    "2519": "Minior Shell",
    "2520": "Milcery Cream",
    "2521": "Duraludon Tarnish",
    "2522": "Articuno Treat",
    "2523": "Zapdos Treat",
    "2524": "Moltres Treat",
    "2525": "Raikou Treat",
    "2526": "Entei Treat",
    "2527": "Suicune Treat",
    "2528": "Lugia Treat",
    "2529": "Ho-Oh Treat",
    "2530": "Latias Treat",
    "2531": "Latios Treat",
    "2532": "Kyogre Treat",
    "2533": "Groudon Treat",
    "2534": "Rayquaza Treat",
    "2535": "Cobalion Treat",
    "2536": "Terrakion Treat",
    "2537": "Virizion Treat",
    "2538": "Reshiram Treat",
    "2539": "Zekrom Treat",
    "2540": "Kyurem Treat",
    "2541": "Solgaleo Treat",
    "2542": "Lunala Treat",
    "2543": "Necrozma Treat",
    "2544": "Kubfu Treat",
    "2545": "Glastrier Treat",
    "2546": "Spectrier Treat",
    "2547": "Indigo Disk",
    "2548": "Fiery Pick",
    "2549": "Stellar Tera Shard",
    "2550": "Chesnaughtite",
    "2551": "Clefablite",
    "2552": "Delphoxite",
    "2553": "Dragoninite",
    "2554": "Drampanite",
    "2555": "Emboarite",
    "2556": "Excadrillite",
    "2557": "Feraligite",
    "2558": "Floettite",
    "2559": "Greninjite",
    "2560": "Golurkite",
    "2561": "Hawluchanite",
    "2562": "Meganiumite",
    "2563": "Meowsticite",
    "2564": "Starmiite",
    "2565": "Victreebelite",
    "2566": "Skarmoryite",
    "2567": "Chandelurite",
    "2568": "Zygardite",
    "2569": "Glimmoranite",
    "2570": "Crabominite",
    "2571": "Raichuite X",
    "2572": "Raichuite Y",
    "2573": "Chimechite",
    "2574": "Absolite Z",
    "2575": "Staraptorite",
    "2576": "Garchompite Z",
    "2577": "Lucarionite Z",
    "2578": "Heatranite",
    "2579": "Darkranite",
    "2580": "Golisopite",
    "2581": "Magearnite",
    "2582": "Zeraorite",
    "2583": "Scovillainite",
    "2584": "Tatsugirite",
    "2585": "Baxcalibrite"
}
export default itemsEn;